import axios from 'axios';

const API_URL = '/api/tenant/sales';

export const fetchSalesTickets = async (params) => {
  try {
    const queryParams = {
      page: params.page,
      pageSize: params.itemsPerPage || 20,
      q: params.q,
      dateFrom: params.dateFrom,
      dateTo: params.dateTo,
    };

    Object.keys(queryParams).forEach((key) => {
      if (
        (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') &&
        key !== 'page' &&
        key !== 'pageSize'
      ) {
        delete queryParams[key];
      }
    });

    const response = await axios.get(`${API_URL}/tickets`, { params: queryParams });
    return response.data;
  } catch (error) {
    console.error('Error fetching sales tickets:', error);
    throw error;
  }
};

export const fetchSalesTicketDetail = async (ticketId) => {
  try {
    const response = await axios.get(`${API_URL}/tickets/${ticketId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ticket detail ${ticketId}:`, error);
    throw error;
  }
};

const cleanParams = (params = {}) => {
  const queryParams = { ...params };
  Object.keys(queryParams).forEach((key) => {
    if (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') {
      delete queryParams[key];
    }
  });
  return queryParams;
};

export const fetchSalesSummaryReportData = async (params) => {
  try {
    const response = await axios.get(`${API_URL}/report/summary/data`, {
      params: cleanParams(params),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching sales summary report:', error);
    throw error;
  }
};

export const downloadSalesSummaryReport = async (params) => {
  try {
    const response = await axios.get(`${API_URL}/report/summary`, {
      params: cleanParams(params),
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading sales summary report:', error);
    throw error;
  }
};

export const fetchSalesTicketsReportData = async (params) => {
  try {
    const response = await axios.get(`${API_URL}/report/tickets/data`, {
      params: cleanParams(params),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching sales tickets report:', error);
    throw error;
  }
};

export const downloadSalesTicketsReport = async (params) => {
  try {
    const response = await axios.get(`${API_URL}/report/tickets`, {
      params: cleanParams(params),
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading sales tickets report:', error);
    throw error;
  }
};

export const fetchSalesSellers = async () => {
  try {
    const response = await axios.get(`${API_URL}/people/sellers`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sales sellers:', error);
    throw error;
  }
};
